import PropTypes from 'prop-types';

import KitoBalloon from '../DataDisplay/Balloon';

import buddyForWave from '../../assets/kitoBuddy/homepage.png';
import whenToWorry from '../../assets/kitoBuddy/Kito-Asking-When-To-Worry 1.png';
import whatToDo from '../../assets/kitoBuddy/Kito-Asking-What-to-do 3.png';
import whatIs from '../../assets/kitoBuddy/Kito-Asking-What-Is 1.png';
import askingFaq from '../../assets/kitoBuddy/Kito-Asking-FAQs 2.png';
import askingQuickCheck from '../../assets/kitoBuddy/Kito-Asking-Quick-Check 1.png';
import congratulations from '../../assets/kitoBuddy/kitoClapMilestone.png';

import styles from './styles.module.css';

const MascotImage = Object.freeze({
  whatToDo,
  buddyForWave,
  whatIs,
  whenToWorry,
  askingFaq,
  askingQuickCheck,
  congratulations
});

function KitoMascot({ image = 'whatToDo', children, mascotWidth = 120, textVariant, stretch = false, ...rest }) {
  return (
    <div className={styles.kitoMascot} data-stretch={stretch} {...rest}>
      <img width={mascotWidth} src={MascotImage[image]} alt="kito-mascot-1" />
      <KitoBalloon marginLeft="-var(--spacing-m)" textVariant={textVariant}>{children}</KitoBalloon>
    </div>
  );
}

KitoMascot.propTypes = {
  image: PropTypes.oneOf(['whatToDo', 'buddyForWave', 'whatIs', 'whenToWorry', 'askingFaq', 'askingQuickCheck', 'congratulations']),
  children: PropTypes.node,
  speech: PropTypes.bool,
  title: PropTypes.bool,
  rest: PropTypes.object,
  mascotWidth: PropTypes.number,
  stretch: PropTypes.bool,
  textVariant: PropTypes.oneOf(['default', 'title']),
};

export default KitoMascot;
